import Vue from 'vue'
import Router from 'vue-router'
import index from '../views/index'
import home from '../views/home'
import product1 from '../views/product/product1'
import product2 from '../views/product/product2'
import startApply from '../views/product/startApply'
import product3 from '../views/product/product3'
import product4 from '../views/product/product4'
import solution1 from '../views/solution/solution1'
import solution2 from '../views/solution/solution2'
import solution3 from '../views/solution/solution3'
import client from '../views/client/client'
import client1 from '../views/client/client1'
import client2 from '../views/client/client2'
import client3 from '../views/client/client3'
import client4 from '../views/client/client4'
import client5 from '../views/client/client5'
import client6 from '../views/client/client6'
import aboutUs from '../views/aboutUs'
import mySite from '../views/mySite'
import agreement from '../views/agreeMent'
import scanReport from '../views/scanReport'


Vue.use(Router);

export default new Router({
  routes: [
    {path: '/', name: 'index', component: index, meta:{keepAlive:true},//需要被缓存
      redirect:'/home',
      children:[
        {
          //首页
          path:'/home',
          name:'home',
          component: home
        }
      ]
    },
    {path:'/',name:'解决方案',component:index,meta:{keepAlive: true},
      children:[
        {
          path:'/solution1',name:'solution1',component:solution1
        },
        {
          path:'/solution2',name:'solution2',component:solution2
        },
        {
          path:'/solution3',name:'solution3',component:solution3
        }
      ]

    },
    {path:'/',name:'产品服务', component:index, meta:{keepAlive:true},
      children:[
        {path: '/product1', name:'product1', component: product1},
        {path: '/product2', name:'product2', component: product2},
        {path: '/startApply', name:'startApply', component: startApply},
        {path:'/product3', name:'product3', component:product3},
        {path:'/product4',name:'product4',component:product4}
      ]
    },
    {
      path:'/',name:'客户案例',component:index,meta:{keepAlive:true},
      children:[
          {path:'/client',name:client,component:client},
          {path:'/client1',component:client1},
          {path:'/client2',component:client2},
          {path:'/client3',component:client3},
          {path:'/client4',component:client4},
          {path:'/client5',component:client5},
          {path:'/client6',component:client6}
        ]
    },
    {
      path:'/',name:'关于我们',component:index,meta:{keepAlive:true},
      children:[
        {path:'/aboutUs', name:'aboutUs', component:aboutUs},//关于我们
      ]
    },
    {
      path:'/',name:'我的网站',component:index,meta:{keepAlive:true},
      children:[
        {path:'/mySite', name:'mySite', component:mySite,meta:{keepAlive:false}}//不需要被缓存
        //关于我们
      ]
    },
    {
      path:'/',name:'用户协议',component:index,meta:{keepAlive:true},
      children:[
        {path:'/agreement', name:'agreement', component:agreement},//用户协议
      ]
    },
    {
      path:'/',name:'漏扫报告',component:index,meta:{keepAlive:true},
      children:[
        {path:'/scanReport', name:'scanReport', component:scanReport},//关于我们
      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js